import {NgModule} from '@angular/core';
import {EiConfigPage} from './page/overview/ei-config/ei-config.page';
import {EiDashboardPage} from './page/overview/ei-dashboard/ei-dashboard.page';
import {
    EiImportRecordStructureObjectComponent
} from './component/protected-components/ei-import-record-structure-object-component/ei-import-record-structure-object.component';
import {
    EiImportRecordObjectComponent
} from './component/protected-components/ei-import-record-object-component/ei-import-record-object.component';
import {
    EiImportObjectComponent
} from './component/protected-components/ei-import-object-component/ei-import-object.component';
import {SiModule} from '../../feature-power/si/si.module';
import {
    EiImportTableWidgetComponent
} from './component/protected-components/ei-import-table-widget-component/ei-import-table-widget.component';
import {
    EiImportObjectWrapperComponent
} from './component/protected-components/ei-import-object-component-wrapper/ei-import-object-wrapper.component';
import {
    EiImportRecordObjectWrapperComponent
} from './component/protected-components/ei-import-record-object-component-wrapper/ei-import-record-object-wrapper.component';
import {WorkbenchPage} from './page/workbench/workbench-page.component';
import {DragDropModule} from 'primeng/dragdrop';
import {WorkbenchLandingComponent} from './page/workbench/components/workbench-landing/workbench-landing.component';
import {WorkbenchMappingComponent} from './page/workbench/components/workbench-mapping/workbench-mapping.component';
import {
    EiImportRecordNotFoundComponent
} from './component/protected-components/ei-import-record-not-found/ei-import-record-not-found.component';
import {
    EiImportAnalyticsComponent
} from './component/protected-components/ei-import-analytics-component/ei-import-analytics.component';
import {
    EiImportObjectSummaryComponent
} from './component/protected-components/ei-import-object-summary/ei-import-object-summary.component';
import {EI_ENTITY_PROVIDER} from './ei.entity-provider';
import {CoreModule} from '../../core/core.module';
import {PMessagesComponent} from '../../core/shared/p-messages/p-messages.component';
import {RouterOutlet} from '@angular/router';
import {EI_TEST_PROVIDERS} from './test/ei-test-definition';
import {EiWorkQueuePage} from './page/work-queue/ei-work-queue.page';
import {EiConflictResolutionComponent} from './component/ei-conflict-resolution/ei-conflict-resolution.component';
import {RuleConfigComponent} from './page/workbench/components/rule-config/rule-config.component';
import {
    EiScopedLookupComponent
} from './component/protected-components/ei-scoped-lookup-component/ei-scoped-lookup.component';
import {
    EiCandidateGenericRendererComponent
} from './component/protected-components/ei-candidate-generic-renderer/ei-candidate-generic-renderer.component';
import {EiImportObjectReviewPage} from './page/object-review/ei-import-object-review.page';
import {EiImportLeitstandPage} from './page/import-leitstand/ei-import-leitstand.page';
import {
    EiImportRecordReviewPanelComponent
} from './component/protected-components/ei-import-record-review-panel/ei-import-record-review-panel.component';
import {
    EiStructureObjectComponent
} from './component/protected-components/ei-structure-object-component/ei-structure-object.component';
import {
    EiStructureBaseComponent
} from './component/protected-components/ei-structure-object-component/view/ei-structure-base.component';
import {
    EiStructureFullComponent
} from './component/protected-components/ei-structure-object-component/view/full/ei-structure-full.component';
import {
    EiStructureBasicComponent
} from './component/protected-components/ei-structure-object-component/shared/ei-structure-basic-component/ei-structure-basic.component';
import {
    EiStructureFieldsComponent
} from './component/protected-components/ei-structure-object-component/shared/ei-structure-fields-component/ei-structure-fields.component';
import {
    EiStructureSearchFieldsComponent
} from './component/protected-components/ei-structure-object-component/shared/ei-structure-search-fields-component/ei-structure-search-fields.component';
import {
    EiStructureQlQueryParamsComponent
} from './component/protected-components/ei-structure-object-component/shared/ei-structure-ql-query-params-component/ei-structure-ql-query-params.component';
import {
    EiStructureValidationQlParamsComponent
} from './component/protected-components/ei-structure-object-component/shared/ei-structure-validation-ql-params-component/ei-structure-validation-ql-params.component';
import {
    EiStructureConditionLogicComponent
} from './component/protected-components/ei-structure-object-component/shared/ei-structure-condition-logic-component/ei-structure-condition-logic.component';
import {
    EiImportTypeComponent
} from './component/protected-components/object-component/ei-import-type-object-component/ei-import-type.component';
import {
    EiImportTypeBaseComponent
} from './component/protected-components/object-component/ei-import-type-object-component/view/ei-import-type-base.component';
import {
    EiImportTypeFullComponent
} from './component/protected-components/object-component/ei-import-type-object-component/view/full/ei-import-type-full.component';
import {
    EiImportTypeBasicComponent
} from './component/protected-components/object-component/ei-import-type-object-component/shared/ei-import-type-basic-component/ei-import-type-basic.component';
import {
    EiImportTypeStructuresComponent
} from './component/protected-components/object-component/ei-import-type-object-component/shared/ei-import-type-structures-component/ei-import-type-structures.component';
import {
    EiImportTypeRulesComponent
} from './component/protected-components/object-component/ei-import-type-object-component/shared/ei-import-type-rules-component/ei-import-type-rules.component';
import {
    EiStructureFieldComponent
} from './component/protected-components/object-component/ei-structure-field-object-component/ei-structure-field.component';
import {
    EiStructureFieldBaseComponent
} from './component/protected-components/object-component/ei-structure-field-object-component/view/ei-structure-field-base.component';
import {
    EiStructureFieldFullComponent
} from './component/protected-components/object-component/ei-structure-field-object-component/view/full/ei-structure-field-full.component';
import {
    EiStructureFieldBasicComponent
} from './component/protected-components/object-component/ei-structure-field-object-component/shared/ei-structure-field-basic-component/ei-structure-field-basic.component';
import {
    EiStructureFieldValuesComponent
} from './component/protected-components/object-component/ei-structure-field-object-component/shared/ei-structure-field-values-component/ei-structure-field-values.component';
import {
    EiStructureFieldImportLogicComponent
} from './component/protected-components/object-component/ei-structure-field-object-component/shared/ei-structure-field-import-logic-component/ei-structure-field-import-logic.component';
import {
    EiDashboardOverviewComponent
} from './page/overview/ei-dashboard/components/ei-dashboard-overview/ei-dashboard-overview.component';
import {
    EiDashboardToolingAreaComponent
} from './page/overview/ei-dashboard/components/ei-dashboard-tooling-area/ei-dashboard-tooling-area.component';
import {
    EiToolingSummaryHeaderComponent
} from './page/overview/ei-dashboard/components/ei-dashboard-tooling-area/components/ei-tooling-summary-header/ei-tooling-summary-header.component';
import {
    EiToolingStageVisualizerCompactComponent
} from './page/overview/ei-dashboard/components/ei-dashboard-tooling-area/components/ei-tooling-stage-visualizer-compact/ei-tooling-stage-visualizer-compact.component';
import {
    EiToolingDetailsTabComponent
} from './page/overview/ei-dashboard/components/ei-dashboard-tooling-area/components/tabs/ei-tooling-details-tab/ei-tooling-details-tab.component';
import {
    EiToolingObjectLookupTabComponent
} from './page/overview/ei-dashboard/components/ei-dashboard-tooling-area/components/tabs/ei-tooling-object-lookup-tab/ei-tooling-object-lookup-tab.component';
import {
    EiToolingObjectSearchTabComponent
} from './page/overview/ei-dashboard/components/ei-dashboard-tooling-area/components/tabs/ei-tooling-object-search-tab/ei-tooling-object-search-tab.component';
import {
    EiToolingLogsTabComponent
} from './page/overview/ei-dashboard/components/ei-dashboard-tooling-area/components/tabs/ei-tooling-logs-tab/ei-tooling-logs-tab.component';
import {
    EiToolingRawDataTabComponent
} from './page/overview/ei-dashboard/components/ei-dashboard-tooling-area/components/tabs/ei-tooling-raw-data-tab/ei-tooling-raw-data-tab.component';
import {
    EiToolingStageVisTabComponent
} from './page/overview/ei-dashboard/components/ei-dashboard-tooling-area/components/tabs/ei-tooling-stage-vis-tab/ei-tooling-stage-vis-tab.component';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {ConfirmationService} from 'primeng/api';
import {MvsConfirmationService} from '../../core/shared/service/confirmation/mvs-confirmation.service';
import {AccordionModule} from 'primeng/accordion';
import {
    EiLeitstandRunHeaderComponent
} from './component/leitstand/ei-leitstand-run-header/ei-leitstand-run-header.component';
import {
    EiLeitstandBalanceComponent
} from './component/leitstand/ei-leitstand-balance/ei-leitstand-balance.component';
import {
    EiLeitstandOpenItemsComponent
} from './component/leitstand/ei-leitstand-open-items/ei-leitstand-open-items.component';
import {
    EiLeitstandOutcomeListComponent
} from './component/leitstand/ei-leitstand-outcome-list/ei-leitstand-outcome-list.component';
import {
    EiLeitstandCorrectionWizardComponent
} from './component/leitstand/ei-leitstand-correction-wizard/ei-leitstand-correction-wizard.component';

// ── hg-gdv-ui-rework branch: import-detail page + its component subtree ──────────
// Additive to dev's Leitstand/Tooling dashboard. Our EiImportObjectComponent is
// aliased to EiImportObjectComponentNew because its class name collides with dev's
// same-named component; the selector (ei-import-object-component-new) is already
// distinct, so both coexist in this NgModule.
import {EiImportObjectComponent as EiImportObjectComponentNew, EiImportDetailPage} from './page/ei-import-detail/ei-import-object.component';
import {EiImportObjectPage} from './page/ei-import-object-page/ei-import-object.page';
import {EiImportDetailHeaderRightComponent} from './page/ei-import-detail/component/ei-import-detail-header-right/ei-import-detail-header-right.component';
import {EiImportPhaseStepperComponent} from './page/ei-import-detail/component/ei-import-phase-stepper/ei-import-phase-stepper.component';
import {EiImportCandidatePanelComponent} from './page/ei-import-detail/component/ei-import-candidate-panel/ei-import-candidate-panel.component';
import {EiImportConflictPanelComponent} from './page/ei-import-detail/component/ei-import-conflict-panel/ei-import-conflict-panel.component';
import {EiImportRecordTreeTableComponent} from './page/ei-import-detail/component/ei-import-record-tree-table/ei-import-record-tree-table.component';
import {EiImportOverviewDistributionCardComponent} from './page/ei-import-detail/component/ei-import-overview-distribution-card/ei-import-overview-distribution-card.component';
import {EiImportRecordOrgChartComponent} from './page/ei-import-detail/component/ei-import-record-org-chart/ei-import-record-org-chart.component';
import {EiImportOverviewSchemaStructureCardComponent} from './page/ei-import-detail/component/ei-import-overview-schema-structure-card/ei-import-overview-schema-structure-card.component';
import {EiReviewWorkbenchComponent} from './component/protected-components/ei-review-workbench/ei-review-workbench.component';
import {EiReviewQueuePanelComponent} from './component/protected-components/ei-review-workbench/queue/ei-review-queue-panel.component';
import {EiReviewRecordCenterComponent} from './component/protected-components/ei-review-workbench/center/ei-review-record-center.component';
import {EiReviewAssignmentPanelComponent} from './component/protected-components/ei-review-workbench/assignment/ei-review-assignment-panel.component';
// Kept from hg-gdv-ui-rework: our EiReviewRecordCenterComponent renders the shared
// <em-schema-runtime-data> viz, which lives in EmModule.
import {EmModule} from '../em/em.module';

@NgModule({
    declarations: [
        EiConfigPage,
        EiDashboardPage,
        EiImportRecordStructureObjectComponent,
        EiImportRecordObjectComponent,
        EiImportObjectComponent,
        EiImportTableWidgetComponent,
        EiImportObjectWrapperComponent,
        EiImportRecordObjectWrapperComponent,
        WorkbenchPage,
        WorkbenchLandingComponent,
        WorkbenchMappingComponent,
        EiImportRecordNotFoundComponent,
        EiImportAnalyticsComponent,
        EiImportObjectSummaryComponent,
        EiWorkQueuePage,
        EiConflictResolutionComponent,
        RuleConfigComponent,
        EiScopedLookupComponent,
        EiCandidateGenericRendererComponent,
        EiImportObjectReviewPage,
        EiImportLeitstandPage,
        EiImportRecordReviewPanelComponent,

        // GDV-Import-Leitstand slot components (M-P4-03)
        EiLeitstandRunHeaderComponent,
        EiLeitstandBalanceComponent,
        EiLeitstandOpenItemsComponent,
        EiLeitstandOutcomeListComponent,
        EiLeitstandCorrectionWizardComponent,

        // EI Structure object components
        EiStructureObjectComponent,
        EiStructureBaseComponent,
        EiStructureFullComponent,
        EiStructureBasicComponent,
        EiStructureFieldsComponent,
        EiStructureSearchFieldsComponent,
        EiStructureQlQueryParamsComponent,
        EiStructureValidationQlParamsComponent,
        EiStructureConditionLogicComponent,

        // EI Import Type object components
        EiImportTypeComponent,
        EiImportTypeBaseComponent,
        EiImportTypeFullComponent,
        EiImportTypeBasicComponent,
        EiImportTypeStructuresComponent,
        EiImportTypeRulesComponent,

        // EI Structure Field object components
        EiStructureFieldComponent,
        EiStructureFieldBaseComponent,
        EiStructureFieldFullComponent,
        EiStructureFieldBasicComponent,
        EiStructureFieldValuesComponent,
        EiStructureFieldImportLogicComponent,

        // EI Dashboard shell components (new)
        EiDashboardOverviewComponent,
        EiDashboardToolingAreaComponent,

        // EI Dashboard Tooling Area — Right-Zone (6 tabs + header + stage-vis)
        EiToolingSummaryHeaderComponent,
        EiToolingStageVisualizerCompactComponent,
        EiToolingDetailsTabComponent,
        EiToolingObjectLookupTabComponent,
        EiToolingObjectSearchTabComponent,
        EiToolingLogsTabComponent,
        EiToolingRawDataTabComponent,
        EiToolingStageVisTabComponent,

        // hg-gdv-ui-rework branch: import-detail page + subtree (additive)
        EiImportObjectPage,
        EiImportObjectComponentNew,
        EiImportDetailPage,
        EiImportDetailHeaderRightComponent,
        EiImportPhaseStepperComponent,
        EiImportCandidatePanelComponent,
        EiImportConflictPanelComponent,
        EiImportRecordTreeTableComponent,
        EiImportOverviewDistributionCardComponent,
        EiImportRecordOrgChartComponent,
        EiImportOverviewSchemaStructureCardComponent,
        EiReviewWorkbenchComponent,
        EiReviewQueuePanelComponent,
        EiReviewRecordCenterComponent,
        EiReviewAssignmentPanelComponent,
    ],
    exports: [
        EiConfigPage,
        EiDashboardPage,
        EiImportRecordStructureObjectComponent,
        EiImportRecordObjectComponent,
        EiImportObjectComponent,
        EiImportTableWidgetComponent,
        EiImportObjectWrapperComponent,
        EiImportRecordObjectWrapperComponent,
        WorkbenchPage,
        WorkbenchLandingComponent,
        WorkbenchMappingComponent,
        EiImportAnalyticsComponent,
        EiWorkQueuePage,
        EiConflictResolutionComponent,
        RuleConfigComponent,
        EiScopedLookupComponent,
        EiCandidateGenericRendererComponent,
        EiImportObjectReviewPage,
        EiImportLeitstandPage,
        EiImportRecordReviewPanelComponent,
        EiStructureObjectComponent,
        EiImportTypeComponent,
        EiStructureFieldComponent
    ],
    imports: [
        CoreModule,
        SiModule,
        DragDropModule,
        PMessagesComponent,
        RouterOutlet,
        ConfirmDialogModule,
        AccordionModule,
        EmModule,
    ],
    providers: [EI_ENTITY_PROVIDER, EI_TEST_PROVIDERS, {provide: ConfirmationService, useClass: MvsConfirmationService}]
})
export class EiModule {
}



